import {useOrderViewStore} from '../../store/pinia/orderview.store';
import Vue, {computed} from 'vue';
import {Store} from 'vuex';
import {STEPS} from '../../services/const.enum';
import {UNTOUCHED} from '../../store/const';

export const setupServiceSettings = (store: Store<any>) => {
  const orderViewStore = useOrderViewStore();

  Vue.component('ServiceSettings', () => import('./components/ServiceSettings.vue'));
  orderViewStore.addCard({
    name: STEPS.SERVICE_SETTINGS,
    step: () => STEPS.SERVICE_SETTINGS,
    isShown: computed(() => store.getters['loggedIn']
      && store.getters['progressByUser'][STEPS.SERVICE_SETTINGS] !== UNTOUCHED
      && store.getters['hasMandatory']),
    isReadOnly: computed(() => false),
  });
};

